import { render, staticRenderFns } from "./addTestQuestionsWJ.vue?vue&type=template&id=86b85682&scoped=true&"
import script from "./addTestQuestionsWJ.vue?vue&type=script&lang=js&"
export * from "./addTestQuestionsWJ.vue?vue&type=script&lang=js&"
import style0 from "./addTestQuestionsWJ.vue?vue&type=style&index=0&id=86b85682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b85682",
  null
  
)

export default component.exports